module.exports = __webpack_public_path__ + "img/scale.98492fba.jpg";